import { Link } from "react-router-dom";
import { Sidebar, SidebarContent, SidebarHeader, SidebarTrigger } from "@/components/ui/sidebar.tsx";
import { Menu } from "@/components/sidebar/menu.tsx";
import LogoSvg from "@/assets/images/logo_black.svg";

export function MenuSideBar() {
  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="flex-row items-center justify-between group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:px-2">
        <Link to="/" className="group-data-[collapsible=icon]:hidden">
          <img src={LogoSvg} alt="logo" className="w-[7.5rem] h-5" />
        </Link>
        <SidebarTrigger />
      </SidebarHeader>
      <SidebarContent>
        <Menu />
      </SidebarContent>
    </Sidebar>
  )
}